import { render } from "./DeviceDataTab.vue?vue&type=template&id=5fe1fb1c&scoped=true"
import script from "./DeviceDataTab.vue?vue&type=script&lang=js"
export * from "./DeviceDataTab.vue?vue&type=script&lang=js"

import "./DeviceDataTab.vue?vue&type=style&index=0&id=5fe1fb1c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fe1fb1c"]])

export default __exports__